import Vue from "vue"
import Buefy from "buefy"

import Cms from "./App.vue"
import CarouselElement from "./components/CarouselElement.vue"
import CarouselForm from "./components/CarouselForm.vue"
import SupplierForm from "./components/SupplierForm.vue"
import SupplierElement from "./components/SupplierElement.vue"
import CaseForm from "./components/CaseForm.vue"
import CaseElement from "./components/CaseElement.vue"
import Banners from "./components/Banners.vue"


Vue.use(Buefy, {
  defaultIconPack: 'fas',
})
Vue.use(Cms)
Vue.use(CarouselElement)
Vue.use(CarouselForm)
Vue.use(SupplierElement)
Vue.use(SupplierForm)
Vue.use(CaseForm)
Vue.use(CaseElement)
Vue.use(Banners)

if (document.getElementById("cmsApp")){
    new Vue({
        render: h => h(
            Cms,{
                props:{
                    slideList:document.getElementById("cmsApp")
                        .getAttribute("slide-list"),
                    slideCreate:document.getElementById("cmsApp")
                        .getAttribute("slide-create"),
                    slideDetail:document.getElementById("cmsApp")
                        .getAttribute("slide-detail"),
                    supplierList:document.getElementById("cmsApp")
                        .getAttribute("supplier-list"),
                    supplierDetail:document.getElementById("cmsApp")
                        .getAttribute("supplier-detail"),
                    supplierCreate:document.getElementById("cmsApp")
                        .getAttribute("supplier-create"),
                    supplierSectionDetail:document.getElementById("cmsApp")
                        .getAttribute("supplier-section-detail"),
                    caseSection:document.getElementById("cmsApp")
                        .getAttribute("case-section"),
                    caseList:document.getElementById("cmsApp")
                        .getAttribute("case-list"),
                    caseDetail:document.getElementById("cmsApp")
                        .getAttribute("case-detail"),
                    caseCreate:document.getElementById("cmsApp")
                        .getAttribute("case-create"),
                    details:document.getElementById("cmsApp")
                        .getAttribute("details"),
                    basicHero:document.getElementById("cmsApp")
                        .getAttribute("basic-hero"),
                    customHero:document.getElementById("cmsApp")
                        .getAttribute("custom-hero"),
                    bannerCreate:document.getElementById("cmsApp")
                        .getAttribute("banner-create"),
                    bannerDetail:document.getElementById("cmsApp")
                        .getAttribute("banner-detail"),
                    bannerList:document.getElementById("cmsApp")
                        .getAttribute("banner-list"),
                    isFullSite: document.getElementById("cmsApp")
                        .getAttribute("is-full-site")
                }
            }
        )
    }).$mount("#cmsApp")
}